const trendsHR = {
    "view": {
        "form": {
            "label": {
                "filters": "Filteri",
                "period": "Razdoblje",
                "store": "Trgovina",
                "label": "Izdavačka kuća",
                "release": "Izdanje",
                "track": "Pjesma",
                "subuser": "Podkorisnik",
                "fetchingTrends": "Dohvaćanje trendova iz baze podataka"
            },
            "button": {
                "resetFilters": "Resetiraj filtere"
            },
            "options": {
                "store": {
                    "allStores": "Sve trgovine",
                    "downloadStores": "Trgovine za preuzimanje",
                    "streamingStores": "Trgovine za streaming",
                    "streamStores": "Trgovine za stream"
                },
                "label": {
                    "allLabels": "Sve izdavačke kuće"
                },
                "release": {
                    "allReleases": "Sva izdanja"
                },
                "track": {
                    "allTracks": "Sve pjesme"
                },
                "subuser": {
                    "selectSubuser": "Odaberi podkorisnika"
                },
                "period": {
                    "last7Days": "Posljednjih 7 dana",
                    "last14Days": "Posljednjih 14 dana",
                    "last30Days": "Posljednjih 30 dana",
                    "last45Days": "Posljednjih 45 dana",
                    "last60Days": "Posljednjih 60 dana",
                    "last75Days": "Posljednjih 75 dana",
                    "last90Days": "Posljednjih 90 dana"
                }
            }
        },
        "top10": {
            "title": "Top 10",
            "table": {
                "column": {
                    "artistName": "Umjetnik",
                    "songMixName": "Naziv pjesme/miksa",
                    "numberOfSales": "Broj prodaja"
                }
            }
        },
        "storeWiseSales": {
            "title": "Prodaja po trgovinama",
            "label": {
                "amazonMusicStream": "Amazon Music stream",
                "appleMusicStream": "Apple Music stream",
                "beatportStream": "Beatport stream",
                "deezerStream": "Deezer stream",
                "facebookStream": "Facebook stream",
                "instagramStream": "Instagram stream",
                "itunesDownload": "iTunes preuzimanje",
                "pandoraStream": "Pandora stream",
                "soundcloudStream": "SoundCloud stream",
                "spotifyStream": "Spotify stream",
                "tiktokStream": "Tiktok stream",
                "traxsourceStream": "Traxsource stream",
                "youtubeStream": "Youtube stream",
                "youtubePremiumStream": "Youtube Premium stream",
                "totalSales": "Ukupna prodaja",
                "storeMessage": "* Oznake trgovina su poredane abecedno (A-Z)"
            }
        },
        "salesByTerritory": {
            "title": "Prodaja po teritorijima"
        },
        "salesByGender": {
            "title": "Prodaja po spolu",
            "label": {
                "male": "Muško",
                "female": "Žensko",
                "nonBinary": "Nebinarno",
                "unknown": "Nepoznato"
            }
        },
        "salesByAge": {
            "title": "Prodaja po dobi",
            "label": {
                "male": "Muško",
                "female": "Žensko",
                "genderOther": "Nebinarno",
                "unknown": "Nepoznato",
                "ageWiseSales": "Prodaja po dobi",
                "ageUnknown": "Dob nepoznata"
            }
        },
        "message": {
            "noAccess": "Nemate pristup ovom modulu, molimo kontaktirajte tim za podršku za dodatne informacije.",
            "subscriptionExpired": "Vaša pretplata je istekla. Molimo <1>obnovite</1> svoju pretplatu kako biste koristili ovu značajku.",
            "subscriptionUpgrade": "Vaš trenutni plan pretplate ne podržava ovu značajku. Molimo <1>nadogradite</1> svoj plan pretplate kako biste koristili ovu značajku."
        }
    }
};

export default trendsHR;